const TOPIC_ITEMS = [
  { tag: '庆余年第二季大结局', hot: '128万' },
  { tag: '长相思虐心名场面', hot: '96万' },
  { tag: '眼泪女王收视率破纪录', hot: '85万' },
  { tag: '与凤行CP感爆棚', hot: '73万' },
  { tag: '墨雨云间复仇爽剧', hot: '68万' },
  { tag: '狐妖小红娘漫改', hot: '55万' },
  { tag: '国产剧古装美学', hot: '49万' },
  { tag: '韩剧全集一次性追完', hot: '42万' },
  { tag: '电视剧免费在线观看', hot: '38万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            剧迷们正在热烈讨论的话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPIC_ITEMS.map((item, i) => {
            const colorClasses = [
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
            ];
            return (
              <div
                key={item.tag}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm cursor-pointer transition-colors ${colorClasses[i]}`}
              >
                <span className="font-medium">#{item.tag}</span>
                <span className="text-xs opacity-70">{item.hot}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}